import { useEffect } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as ReactPostHogProvider } from 'posthog-js/react'

import config from '@/config'

interface Props {
  children: React.ReactNode
}

export const PostHogProvider = ({ children }: Props) => {
  const isDev = config.BUILD_ENV !== 'prod'

  useEffect(() => {
    if (isDev) return

    posthog.init(config.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: '/ph',
      ui_host: 'https://us.posthog.com',
      capture_pageview: 'history_change',
      capture_exceptions: true
      // loaded: ph => {
      //   if (isDev) ph.debug()
      // },
      // debug: isDev
    })
  }, [isDev])

  if (isDev) {
    return <>{children}</>
  }

  return (
    <ReactPostHogProvider client={posthog}>{children}</ReactPostHogProvider>
  )
}

// Below is for use with SSR pages - untested
// import { PostHog } from 'posthog-node'

// export function PostHogClient() {
//   const posthogClient = new PostHog(config.NEXT_PUBLIC_POSTHOG_KEY!, {
//     host: config.NEXT_PUBLIC_POSTHOG_HOST,
//     capture_pageview: 'history_change',
//     flushAt: 1,
//     flushInterval: 0
//   })
//   return posthogClient
// }
